export enum GameStates {
  NotStarted,
  Started,
  Finished,
}
